import React from 'react';
import knitting from '../images/knitting-banner.jpg';
import Layout from './Layout';

function Home() {
    return (
        <Layout>
            <section className="about_section layout_padding long_section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="img-box">
                                <img src={knitting} alt="knitting" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="detail-box">
                                <div className="heading_container">
                                    <h1>
                                        Coming soon!
                                    </h1>
                                </div>
                                <p>Build your own pattern. Insert your own measurements to get a perfect jumper pattern.</p>
                                <a href="">
                                    Build
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
}

export default Home;